import { Link } from "react-router-dom";
import { Settings, Bell, Gift, Ticket, Shield, HelpCircle, LogOut, Crown, Sparkles } from "lucide-react";
import { StudioShell } from "./StudioShell";
import { useLanguage } from "../contexts/LanguageContext";

export default function StudioMore() {
  const { t } = useLanguage();
  const LINKS = [
    { to: "/dashboard?tab=profile", icon: Settings, label: t.studio_more_settings || "Account settings" },
    { to: "/dashboard?tab=notifications", icon: Bell, label: t.studio_more_notifications || "Notifications" },
    { to: "/dashboard?tab=plan", icon: Crown, label: t.studio_more_plan || "Plan & billing" },
    { to: "/community/top-sharers", icon: Gift, label: t.studio_more_invite || "Invite friends" },
    { to: "/redeem", icon: Ticket, label: t.studio_more_redeem || "Redeem a coupon" },
    { to: "/ads-creator/instant-campaign", icon: Sparkles, label: t.studio_more_ai || "AI Magic" },
    { to: "/privacy", icon: Shield, label: t.studio_more_privacy || "Privacy" },
    { to: "/blog", icon: HelpCircle, label: t.studio_more_help || "Help & Blog" },
  ];
  return (
    <StudioShell activeKey="/studio/more">
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "40px 20px 40px" }}
        data-testid="studio-more-page">
        <h1 style={{ color: "#fff", fontSize: 32, fontWeight: 900, margin: "0 0 6px", letterSpacing: "-0.02em" }}>
          {t.studio_more_title || "More"}
        </h1>
        <p style={{ color: "#a5a5c0", fontSize: 14, margin: "0 0 28px" }}>
          {t.studio_more_sub || "Settings, account and other tools."}
        </p>
        <div style={{
          background: "rgba(20,20,35,0.72)",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: 14, overflow: "hidden",
        }}>
          {LINKS.map(({ to, icon: Icon, label }, i) => (
            <Link
              key={to}
              to={to}
              data-testid={`studio-more-link-${i}`}
              style={{
                display: "flex", alignItems: "center", gap: 14,
                padding: "14px 16px", color: "#fff", textDecoration: "none",
                borderBottom: i < LINKS.length - 1 ? "1px solid rgba(255,255,255,0.06)" : "none",
                transition: "background 120ms ease",
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.04)"}
              onMouseLeave={(e) => e.currentTarget.style.background = ""}
            >
              <span style={{
                width: 36, height: 36, borderRadius: 10,
                background: "rgba(168,85,247,0.12)", color: "#c084fc",
                display: "inline-flex", alignItems: "center", justifyContent: "center",
              }}>
                <Icon size={18} />
              </span>
              <span style={{ flex: 1, fontSize: 15, fontWeight: 700 }}>{label}</span>
              <span style={{ color: "#555", fontSize: 20 }}>›</span>
            </Link>
          ))}
        </div>
        <button
          type="button"
          onClick={() => {
            try { localStorage.removeItem("access_token"); } catch { /* ignore */ }
            window.location.href = "/";
          }}
          data-testid="studio-more-logout"
          style={{
            width: "100%", marginTop: 16, padding: "12px 14px",
            background: "rgba(248,113,113,0.08)",
            border: "1px solid rgba(248,113,113,0.3)",
            borderRadius: 12, color: "#fca5a5", fontSize: 14, fontWeight: 800,
            cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8,
          }}
        >
          <LogOut size={16} /> {t.studio_more_logout || "Log out"}
        </button>
      </div>
    </StudioShell>
  );
}
